/**
 * 自动回复消息序列公共辅助（AutoReplyPanel / AutoReplyMessagesEditor / FollowUpPanel 共用）。
 * 消息结构：{ type: 'text'|'voice'|'video'|'micro_program', content }，
 * content 与快捷回复同格式（text 为原文，其余为对应 Elem JSON）
 */

// 兼容本地缓存未携带 messages 的旧结构（纯文本按单条文字处理）
export function scriptMessages(script) {
  if (script && Array.isArray(script.messages) && script.messages.length) return script.messages
  if (script && script.content) return [{ type: 'text', content: script.content }]
  return []
}

export function parseElem(content) {
  try {
    return JSON.parse(content || '{}')
  } catch (e) {
    return {}
  }
}

export function msgIcon(m) {
  const map = {
    text: 'el-icon-chat-dot-round',
    voice: 'el-icon-microphone',
    video: 'el-icon-video-camera',
    micro_program: 'el-icon-cpu'
  }
  return (m && map[m.type]) || 'el-icon-chat-dot-round'
}

export function microTitleFromContent(content) {
  const d = parseElem(content)
  return d.title || d.appName || '小程序素材'
}

// 消息预览（full=true 时文字不做截断）
export function msgPreview(m, full = false) {
  if (!m) return ''
  if (m.type === 'voice') {
    const d = parseElem(m.content)
    return `[语音] ${d.duration || 0}″`
  }
  if (m.type === 'video') {
    const d = parseElem(m.content)
    return `[视频] ${d.name || ''}`
  }
  if (m.type === 'micro_program') {
    return `[小程序] ${microTitleFromContent(m.content)}`
  }
  const text = m.content || ''
  return !full && text.length > 30 ? text.slice(0, 30) + '…' : text
}

// 历史数据 weappIconUrl 可能带字面 \u0026，展示前清洗（与快捷回复同口径）
export function cleanMicroIcon(url) {
  return (url || '').replace(/\\u0026/g, '&')
}

// 单条话术最多消息条数（与后端 models.MaxAutoReplyMessages 保持一致）
export const MAX_MSGS = 10
